import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const ContentBuilder = () => (
  <ComponentDocs
    name="<ContentBuilder/>"
    entry="ContentBuilder"
    propsEntry="ContentBuilderProps"
  >
    <ComponentExample
      name="Load and display data"
      import={import(
        "examples/Builders/ContentBuilder/LoadAndDisplayDataExample"
      )}
      rawImport={import(
        "examples/Builders/ContentBuilder/LoadAndDisplayDataExample?raw"
      )}
    />
    <ComponentExample
      name="Load action params"
      import={import(
        "examples/Builders/ContentBuilder/LoadActionParamsExample"
      )}
      rawImport={import(
        "examples/Builders/ContentBuilder/LoadActionParamsExample?raw"
      )}
    />
    <ComponentExample
      name="Load data transform"
      import={import(
        "examples/Builders/ContentBuilder/LoadDataTransformExample"
      )}
      rawImport={import(
        "examples/Builders/ContentBuilder/LoadDataTransformExample?raw"
      )}
    />
    <ComponentExample
      name="Custom loading / error"
      import={import(
        "examples/Builders/ContentBuilder/CustomLoadingAndErrorExample"
      )}
      rawImport={import(
        "examples/Builders/ContentBuilder/CustomLoadingAndErrorExample?raw"
      )}
    />
    <ComponentExample
      name="Abort loading"
      import={import("examples/Builders/ContentBuilder/AbortLoadingExample")}
      rawImport={import(
        "examples/Builders/ContentBuilder/AbortLoadingExample?raw"
      )}
    />
  </ComponentDocs>
);

export default ContentBuilder;
